"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetricQuery = void 0;
function getMetricQuery(measures, dateRange, filters, type = 'number', complexQueries, resultProcessor, timeDimension = 'Attribution.date') {
    const baseQuery = {
        measures,
        timeDimensions: [
            {
                dimension: timeDimension,
                dateRange,
            },
        ],
        order: {},
        filters,
        dimensions: [],
    };
    return {
        queries: complexQueries
            ? complexQueries.map(query => (Object.assign(Object.assign({}, baseQuery), query)))
            : [baseQuery],
        resultProcessor: resultProcessor ||
            (rows => {
                return {
                    value: rows[0].seriesNames().map(s => rows[0].totalRow()[s.key])[0],
                    type,
                };
            }),
    };
}
exports.getMetricQuery = getMetricQuery;
//# sourceMappingURL=helper.js.map